// Mock data for Hello Foundation website

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Our Causes', href: '#causes' },
  { label: 'Impact', href: '#impact' },
  { label: 'Hello Support', href: '#hello-support' },
  { label: 'Updates', href: '#instagram' },
  { label: 'Contact', href: '#contact' },
];

export const IMPACT_STATS = [
  { value: '250,000+', label: 'Meals per Annum Goal', accent: 'coral' },
  { value: '600', label: 'Meals Served Daily', accent: 'blue' },
  { value: '6', label: 'Communities Served', accent: 'magenta' },
  { value: '1M+', label: 'Plates Served Since Inception', accent: 'purple' },
];

export const CAUSES = [
  {
    id: 1,
    title: 'Fighting Hunger',
    tagline: 'One warm plate at a time',
    description:
      'Hello Foundation was founded to make a difference in impoverished communities where children often go hungry for days. Today we serve ~600 meals a day across 6 communities in Gauteng and the Western Cape.',
    image:
      'https://images.unsplash.com/photo-1694286068611-d0c24cbc2cd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxmZWVkaW5nJTIwY2hpbGRyZW58ZW58MHx8fHwxNzgzMDU5NzEzfDA&ixlib=rb-4.1.0&q=85',
    stats: '600 meals / day',
    cta: 'Fight Hunger With Us',
    email: 'm.ebrahim@hellogroup.co.za?subject=Let%20Us%20Fight%20Hunger%20Together',
  },
  {
    id: 2,
    title: 'Fighting Poverty',
    tagline: 'Dignity for every community',
    description:
      'Our goal is to ensure that the most vulnerable and at-risk groups in our communities have their basic needs met. With generous donations and volunteering efforts, we tackle poverty at its roots.',
    image:
      'https://images.unsplash.com/photo-1628717341663-0007b0ee2597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjB2b2x1bnRlZXJzfGVufDB8fHx8MTc4MzA1OTcwNXww&ixlib=rb-4.1.0&q=85',
    stats: '6 communities · GP + WC',
    cta: 'Help Us Fight Poverty',
    email: 'm.ebrahim@hellogroup.co.za?subject=Help%20The%20Helpers%20Fight%20Poverty%20Together',
  },
  {
    id: 3,
    title: 'Youth Mental Wellness',
    tagline: 'Coming 2027 — Hello Support',
    description:
      'Our newest initiative launching in 2027. Free, confidential online counselling for South African children, teenagers, and their caregivers. Because mental health support shouldn’t have a waiting list — or a price tag.',
    image:
      'https://images.unsplash.com/photo-1758273240403-052b3c99f636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHx5b3V0aCUyMHdlbGxuZXNzfGVufDB8fHx8MTc4MzA1OTcwNXww&ixlib=rb-4.1.0&q=85',
    stats: 'Launching 2027',
    cta: 'Learn About Hello Support',
    email: 'm.ebrahim@hellogroup.co.za?subject=Hello%20Support%20Initiative',
  },
];

export const HELLO_SUPPORT_FEATURES = [
  {
    title: 'Book a session',
    desc: 'Pick a counsellor, choose a time that fits your day, get a confirmation instantly. No waiting rooms.',
    icon: 'CalendarCheck',
  },
  {
    title: 'Talk face-to-face online',
    desc: 'Each booking includes a private video room — open it from your dashboard at session time.',
    icon: 'Video',
  },
  {
    title: 'Chat between sessions',
    desc: 'Send a quick message to your counsellor when something is on your mind. Always private.',
    icon: 'MessageCircle',
  },
  {
    title: 'Self-help library',
    desc: 'Short videos on anxiety, bullying, coping skills, mindfulness and more — curated by our team.',
    icon: 'BookOpen',
  },
  {
    title: 'Session records',
    desc: 'Look back at session summaries your counsellor shares with you — progress is yours to keep.',
    icon: 'FileText',
  },
  {
    title: 'Confidential by design',
    desc: 'Your conversations stay between you and your counsellor. Always.',
    icon: 'ShieldCheck',
  },
];

export const SPONSOR_TIERS = [
  {
    id: 1,
    title: 'Sponsor 1 session',
    amount: 'R 150',
    amountValue: 150,
    desc: 'Funds one full 50-minute counselling session for a young person.',
    highlight: false,
  },
  {
    id: 2,
    title: 'Sponsor 3 sessions',
    amount: 'R 450',
    amountValue: 450,
    desc: 'A month of support — three sessions to walk alongside a teen through tough weeks.',
    highlight: true,
  },
  {
    id: 3,
    title: 'Sponsor a month of care',
    amount: 'R 900',
    amountValue: 900,
    desc: 'Six sessions plus parent guidance — full-spectrum care for one family.',
    highlight: false,
  },
];

export const DONATION_TIERS = [
  { id: 1, amount: 150, meals: 15, label: 'Feed 15 kids for a day' },
  { id: 2, amount: 350, meals: 35, label: 'A week of school meals' },
  { id: 3, amount: 700, meals: 70, label: 'Support a family for a month' },
  { id: 4, amount: 1500, meals: 150, label: 'Sustain a soup kitchen weekly' },
];

export const INSTAGRAM_POSTS = [
  {
    id: 1,
    image:
      'https://images.unsplash.com/photo-1509099836639-18ba1795216d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwY2hpbGRyZW58ZW58MHx8fHwxNzgzMDU5NzA0fDA&ixlib=rb-4.1.0&q=85',
    caption: 'Every smile is a reason to keep going. Feeding day at Tsakani township.',
    likes: 342,
    comments: 28,
    date: '2d ago',
  },
  {
    id: 2,
    image:
      'https://images.unsplash.com/photo-1628428799437-d886d7d2e9b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxzb3VwJTIwa2l0Y2hlbnxlbnwwfHx8fDE3ODMwNTk3MDR8MA&ixlib=rb-4.1.0&q=85',
    caption: 'Our volunteers prepared 620 meals today across all three locations.',
    likes: 512,
    comments: 41,
    date: '4d ago',
  },
  {
    id: 3,
    image:
      'https://images.unsplash.com/flagged/photo-1555251255-e9a095d6eb9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwY2hpbGRyZW58ZW58MHx8fHwxNzgzMDU5NzA0fDA&ixlib=rb-4.1.0&q=85',
    caption: 'Little heroes brightening our day. Thank you to everyone who donates.',
    likes: 421,
    comments: 33,
    date: '1w ago',
  },
  {
    id: 4,
    image:
      'https://images.unsplash.com/photo-1774223146476-b1977e9f0f8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxjb21tdW5pdHklMjBtZWFsfGVufDB8fHx8MTc4MzA1OTcxMnww&ixlib=rb-4.1.0&q=85',
    caption: 'Community means showing up. Together we served over 600 meals this morning.',
    likes: 289,
    comments: 19,
    date: '1w ago',
  },
  {
    id: 5,
    image:
      'https://images.unsplash.com/photo-1625940949493-91ac054804e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxzb3VwJTIwa2l0Y2hlbnxlbnwwfHx8fDE3ODMwNTk3MDR8MA&ixlib=rb-4.1.0&q=85',
    caption: 'From our kitchen to their table. Every plate tells a story of hope.',
    likes: 617,
    comments: 52,
    date: '2w ago',
  },
  {
    id: 6,
    image:
      'https://images.unsplash.com/photo-1593113598332-cd288d649433?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjB2b2x1bnRlZXJzfGVufDB8fHx8MTc4MzA1OTcwNXww&ixlib=rb-4.1.0&q=85',
    caption: 'Volunteer day! Thank you to the Hello Group family for the ongoing support.',
    likes: 398,
    comments: 24,
    date: '2w ago',
  },
  {
    id: 7,
    image:
      'https://images.unsplash.com/photo-1521493959102-bdd6677fdd81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxBZnJpY2FuJTIwY2hpbGRyZW58ZW58MHx8fHwxNzgzMDU5NzA0fDA&ixlib=rb-4.1.0&q=85',
    caption: 'The next generation. Their smiles keep us going.',
    likes: 723,
    comments: 68,
    date: '3w ago',
  },
  {
    id: 8,
    image:
      'https://images.unsplash.com/photo-1777427676365-d84b81691767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBtZWFsfGVufDB8fHx8MTc4MzA1OTcxMnww&ixlib=rb-4.1.0&q=85',
    caption: 'Hot meals ready to be shared across our Gauteng locations.',
    likes: 456,
    comments: 31,
    date: '3w ago',
  },
];

// ============================================================
// Instagram embeds — paste real post/reel URLs from @hello_fund here.
// Examples:
//   'https://www.instagram.com/p/ABC123xyz/',
//   'https://www.instagram.com/reel/XYZ789abc/',
// If this array is empty, the site falls back to the curated mock grid above.
// ============================================================
export const INSTAGRAM_EMBEDS = [
  // Add real Instagram post/reel URLs below to display them as live embeds.
];

// ============================================================
// SnapWidget embed — paste the full <iframe> src URL from SnapWidget here.
// Get it at https://snapwidget.com (Instagram → Public Profile → hello_fund)
// Example: 'https://snapwidget.com/embed/1234567'
// If empty, the site falls back to Behold → embeds → mock grid.
// ============================================================
export const SNAPWIDGET_URL = '';
export const SNAPWIDGET_HEIGHT = 640;

// ============================================================
// Behold.so Feed ID — for auto-updating @hello_fund posts.
// Sign up at https://behold.so, connect Instagram, copy your Feed ID here.
// Example: 'abc123XYZ'
// If empty, the site falls back to INSTAGRAM_EMBEDS or the mock grid.
// ============================================================
export const BEHOLD_FEED_ID = '';
export const BEHOLD_POST_COUNT = 8;

export const TESTIMONIALS = [
  {
    id: 1,
    quote:
      'Great things are done by a series of small things brought together.',
    author: 'Vincent van Gogh',
  },
  {
    id: 2,
    quote:
      'The best way to find yourself is to lose yourself in the service of others.',
    author: 'Mahatma Gandhi',
  },
  {
    id: 3,
    quote:
      'No one has ever become poor by giving.',
    author: 'Anne Frank',
  },
];

export const TIMELINE = [
  {
    year: 'April 2020',
    title: 'Foundation Established',
    desc: 'Born from the Covid-19 crisis with a mission to feed 100 kids daily in Tsakani township.',
  },
  {
    year: '2020',
    title: '75,000 Meals in 170 Days',
    desc: 'Rapidly scaled operations during the first lockdown to meet urgent community needs.',
  },
  {
    year: '2023',
    title: 'Expanded to 6 Communities',
    desc: 'Serving 600 meals per day across 5 Gauteng communities and Macassar in the Western Cape.',
  },
  {
    year: '2025',
    title: '1 Million Plates Milestone',
    desc: 'A landmark moment — over one million plates served since inception across our 6 communities.',
  },
  {
    year: '2027',
    title: 'Hello Support Launches',
    desc: 'Youth Mental Wellness & Support — free confidential counselling for South African youth.',
    highlight: true,
  },
];

export const COMMUNITIES = [
  { name: 'Tsakane', province: 'Gauteng' },
  { name: 'Tembisa', province: 'Gauteng' },
  { name: 'Vosloorus', province: 'Gauteng' },
  { name: 'Kingsway Informal Settlement', province: 'Gauteng' },
  { name: 'Lahae', province: 'Gauteng' },
  { name: 'Macassar', province: 'Western Cape' },
];

export const CONTACT = {
  address: 'Hello House — Building 12 Akkerboom Street, Centurion Gate Business Park',
  email: 'mebrahim@hellogroup.co.za',
  phone: '0861 666 786',
  bank: {
    name: 'FNB Current Account',
    accNo: '628 4511 4066',
    branch: '250 655',
  },
};
